"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.beforeValue = void 0;
const react_1 = require("react");
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const gpsStorageCtrl_1 = require("../modules/gpsStorageCtrl");
const hangul = __importStar(require("hangul-js"));
const autoCompResult_1 = require("../modules/autoComplete/autoCompResult");
const checkUserAgent_1 = require("../utils/checkUserAgent");
// const debounce = (callback: any, delay: any) => {
//   let timer: any;
//   return (...args: any) => {
//     // 실행한 함수(setTimeout())를 취소
//     clearTimeout(timer);
//     // delay가 지나면 callback 함수를 실행
//     timer = setTimeout(() => callback(...args), delay);
//   };
// };
const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
const userAgent = (0, checkUserAgent_1.checkUserAgent)();
let eventCnt = 0;
let isHangulWait = false;
let isFirstReq = false;
exports.beforeValue = "";
let currentInput = "";
let reqQueue = [];
const english = /[a-zA-Z]/;
setTimeout(() => {
    // localConsole?.log(performance.getEntriesByName("debounce"), "debounce mark");
    // localConsole?.log(
    //   performance.getEntriesByName("autoValue"),
    //   "autoValue mark"
    // );
    // localConsole?.log(
    //   performance.getEntriesByName("hangulWait"),
    //   "hangulWait mark"
    // );
    // localConsole?.log(
    //   performance.getEntriesByName("updateValue"),
    //   "updateValue mark"
    // );
}, 10000);
const useAutoComplete = (sec, setAutoValue, setMonitor) => {
    let actionValue = "";
    const autoValueFetcher = (0, react_1.useCallback)(async (inputValue) => {
        if (inputValue.length === 1) {
            if (!english.test(inputValue) && !hangul.isComplete(inputValue)) {
                isHangulWait = true;
                hangulWaiter(inputValue);
                return;
            }
        }
        if (!english.test(inputValue[inputValue.length - 1]) &&
            !hangul.isComplete(inputValue[inputValue.length - 1])) {
            isHangulWait = true;
            hangulWaiter(inputValue);
            return;
        }
        performance.mark("autoValue");
        if (setMonitor) {
            setMonitor((monitor) => ({
                ...monitor,
                autoValuePerform: performance.getEntriesByName("autoValue"),
            }));
        }
        reqQueue.push(inputValue);
        const autoRes = (0, autoCompResult_1.getAutoRes)({ inputValue, lat, lon: lng }).then(({ reqText, restRes, keywordRes }) => {
            const reqindex = reqQueue.findIndex((reqstr) => reqstr === reqText);
            if (reqindex === 0) {
                reqQueue.shift();
            }
            else if (reqindex > 0) {
                reqQueue.splice(0, reqindex + 1);
            }
            else {
                return;
            }
            (0, autoCompResult_1.autoCompResultSetter)({
                key: inputValue,
                restValue: restRes,
                keywordValue: keywordRes,
                reqText: reqText,
                setAutoValue,
            });
        });
    }, []);
    const debouncedFetcher = (0, react_1.useCallback)((0, lodash_debounce_1.default)(async (inputValue) => {
        if (inputValue.length === 1) {
            if (!english.test(inputValue) && !hangul.isComplete(inputValue)) {
                isHangulWait = true;
                debouncedFetcher.cancel();
                hangulWaiter(inputValue);
                return;
            }
        }
        if (!english.test(inputValue[inputValue.length - 1]) &&
            !hangul.isComplete(inputValue[inputValue.length - 1])) {
            isHangulWait = true;
            debouncedFetcher.cancel();
            hangulWaiter(inputValue);
            return;
        }
        // 디바운싱 이후 처리 로직
        performance.mark("debounce");
        if (setMonitor) {
            setMonitor((monitor) => ({
                ...monitor,
                debouncePerform: performance.getEntriesByName("debounce"),
            }));
        }
        reqQueue.push(inputValue);
        (0, autoCompResult_1.getAutoRes)({ inputValue, lat, lon: lng }).then(({ reqText, restRes, keywordRes }) => {
            const reqindex = reqQueue.findIndex((reqstr) => reqstr === reqText);
            if (reqindex === 0) {
                reqQueue.shift();
            }
            else if (reqindex > 0) {
                reqQueue.splice(0, reqindex + 1);
            }
            else {
                return;
            }
            (0, autoCompResult_1.autoCompResultSetter)({
                key: inputValue,
                restValue: restRes,
                keywordValue: keywordRes,
                reqText: reqText,
                setAutoValue,
            });
        });
    }, sec, { maxWait: 1 }), []);
    const hangulWaiter = (0, react_1.useCallback)((0, lodash_debounce_1.default)(async (inputValue) => {
        // 디바운싱 이후 처리 로직
        performance.mark("hangulWait");
        if (setMonitor) {
            setMonitor((monitor) => ({
                ...monitor,
                hangulWaitPerform: performance.getEntriesByName("hangulWait"),
            }));
        }
        reqQueue.push(inputValue);
        (0, autoCompResult_1.getAutoRes)({ inputValue, lat, lon: lng }).then(({ reqText, restRes, keywordRes }) => {
            const reqindex = reqQueue.findIndex((reqstr) => reqstr === reqText);
            if (reqindex === 0) {
                reqQueue.shift();
            }
            else if (reqindex > 0) {
                reqQueue.splice(0, reqindex + 1);
            }
            else {
                return;
            }
            (0, autoCompResult_1.autoCompResultSetter)({
                key: inputValue,
                restValue: restRes,
                keywordValue: keywordRes,
                reqText: reqText,
                setAutoValue,
            });
        });
        isHangulWait = false;
    }, sec * 2, { maxWait: sec * 2 }), []);
    const updateValue = (inputValue, force, isConverted) => {
        actionValue = inputValue.trimStart();
        currentInput = actionValue;
        if (!force && exports.beforeValue === actionValue) {
            return;
        }
        exports.beforeValue = inputValue.trimStart();
        if (!inputValue) {
            if (userAgent === "ios" || userAgent === "android") {
                isHangulWait = false;
                isFirstReq = false;
                hangulWaiter.cancel();
                debouncedFetcher.cancel();
                setAutoValue({ rest: null, keyword: null });
                return;
            }
            setAutoValue({ rest: null, keyword: null });
            return;
        }
        eventCnt += 1;
        if (setMonitor) {
            setMonitor((monitor) => ({ ...monitor, evtCnt: eventCnt }));
        }
        if (force) {
            autoValueFetcher(actionValue);
            return;
        }
        if (actionValue && actionValue.length === 1 && isFirstReq === false) {
            isHangulWait = false;
            isFirstReq = true;
            hangulWaiter.cancel();
            debouncedFetcher.cancel();
            autoValueFetcher(actionValue);
            return;
        }
        if (isHangulWait === true &&
            actionValue &&
            hangul.isComplete(actionValue[actionValue.length - 1])) {
            isHangulWait = false;
            hangulWaiter.cancel();
            debouncedFetcher.cancel();
            autoValueFetcher(actionValue);
            return;
        }
        if (actionValue && isHangulWait === false) {
            debouncedFetcher(actionValue);
            return;
        }
    };
    return { actionValue, updateValue };
};
exports.default = useAutoComplete;
